export default __webpack_public_path__ + "static/media/warning-illus.f20c32e3.svg";